module.exports=require('./lib/picker.vue')